import { useQuery } from '@tanstack/react-query'

import { getLocations } from '../api/getLocations'

export const useLocations = () =>
	useQuery({
		queryKey: ['GET_LOCATIONS'],
		queryFn: getLocations,
		staleTime: Infinity,
	})
